import {isFeatureEnabled} from '@github-ui/feature-flags'
import {
  BulkIssueMilestonePicker as BulkIssueMilestonePickerFuture,
  fetchMilestones as fetchMilestonesFuture,
  MilestonePicker as MilestonePickerFuture,
  type MilestonePickerSharedMilestoneKey,
  readMilestoneFromFragment as readMilestoneFromFragmentFuture,
} from '@github-ui/item-picker-milestone-relay'
import type {Environment} from 'relay-runtime'

import type {MilestonePickerMilestone$key} from './__generated__/MilestonePickerMilestone.graphql'
import type {MilestonePickerQuery} from './__generated__/MilestonePickerQuery.graphql'
import {
  BulkIssueMilestonePicker as BulkIssueMilestonePickerLegacy,
  fetchMilestones as fetchMilestonesLegacy,
  MilestonePicker as MilestonePickerLegacy,
  readMilestoneFromFragment as readMilestoneFromFragmentLegacy,
} from './MilestonePicker'

// eslint-disable-next-line no-barrel-files/no-barrel-files
export {MilestonesPickerGraphqlQuery} from './MilestonePicker'

export async function fetchMilestones(
  environment: Environment,
  options: {
    owner: string
    repo: string
    query: string
    count?: number
  },
) {
  const ffEnabled = isFeatureEnabled('item_picker_milestone_relay_migration')
  return ffEnabled ? fetchMilestonesFuture(environment, options) : fetchMilestonesLegacy(environment, options)
}

export function MilestonePicker(props: React.ComponentProps<typeof MilestonePickerLegacy>) {
  const ffEnabled = isFeatureEnabled('item_picker_milestone_relay_migration')
  return ffEnabled ? <MilestonePickerFuture {...props} /> : <MilestonePickerLegacy {...props} />
}

export function BulkIssueMilestonePicker(props: React.ComponentProps<typeof BulkIssueMilestonePickerLegacy>) {
  const ffEnabled = isFeatureEnabled('item_picker_milestone_relay_migration')
  return ffEnabled ? <BulkIssueMilestonePickerFuture {...props} /> : <BulkIssueMilestonePickerLegacy {...props} />
}

export function readMilestoneFromFragment(key: MilestonePickerMilestone$key | MilestonePickerSharedMilestoneKey) {
  const ffEnabled = isFeatureEnabled('item_picker_milestone_relay_migration')
  return ffEnabled
    ? readMilestoneFromFragmentFuture(key as MilestonePickerSharedMilestoneKey)
    : readMilestoneFromFragmentLegacy(key as MilestonePickerMilestone$key)
}

export type MilestonePickerTestQueries = {
  MilestonePickerQuery: MilestonePickerQuery
}

try{ MilestonePicker.displayName ||= 'MilestonePicker' } catch {}
try{ BulkIssueMilestonePicker.displayName ||= 'BulkIssueMilestonePicker' } catch {}